import { Space } from "antd";
import styled from "styled-components";
import { ICON_SPIN } from "@assets";

export const Container = styled(Space)`
  width: 100%;
  max-width: 480px;
  height: 70px;
  padding: 0;
  align-items: center;
  text-align: center;
  position: fixed;
  bottom: 0;
  border-radius: 16px 16px 0px 0px;
  background: ${props => props.theme.navbarColor};

  .ant-space-item {
    flex: 0.25;
  }

  @media screen and (max-width: 395px) {
    gap: 0 !important;
  }
`;

export const ItemWrapper = styled.div`
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0;
`;

export const Label = styled.div`
  font-size: 10px;
  font-style: normal;
  letter-spacing: normal;
  line-height: 1.5;
  font-weight: ${(props) => (props.status === "active" ? "600" : "200")};
  color: ${(props) => (props.status === "active" ? "#FFB829" : "#686B6E")};

  @media screen and (max-width: 330px) {
    font-size: 9px;
  }

  @media screen and (max-width: 298px) {
    font-size: 9px;
  }

  @media screen and (max-width: 272px) {
    font-size: 8px;
  }
`;

export const SpinFilled = styled.img.attrs({
  alt: 'icon-spin',
  src: ICON_SPIN,
})`
max-width: 50px;
margin-bottom: 12px;
`;